import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { retryWhen, delay, take, tap } from 'rxjs/operators';
import { FaqModel } from 'src/models/faq.model';
import { FaqService } from 'src/services/faq/faq.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
  faqs: Array<FaqModel>;
  activeFaq: number | null = null;

  constructor(public faqService: FaqService, private meta: Meta) { }

  ngOnInit(): void {
    this.meta.addTag({ name: 'description', content: "FAQ" });
    this.meta.addTag({ name: 'keywords', content: 'BSTP Guinée, BSTP, bstpgn, ' });
    this.meta.addTag({ name: 'author', content: 'BSTP Guinée' });
    this.faqService.list().pipe(
      retryWhen(errors =>
        errors.pipe(
          delay(500),  // attendre 2s
          take(3),      // réessayer 3 fois
          tap(() => console.log('Nouvelle tentative...'))
        )
      )
    ).subscribe((faqs: Array<FaqModel>) => {
      this.faqService.update(faqs);
      this.faqs = faqs;
    });
    $.getScript('assets/js/custom.js');
  }

  toggleFaq(index: number): void {
    if (this.activeFaq === index) {
      this.activeFaq = null;
    } else {
      this.activeFaq = index;
    }
  }
}
